import axios from "axios";
import React, { Dispatch, SetStateAction } from 'react';
import { AnyIfEmpty } from "react-redux";
import { GET_VENDOR_APPOINTMENT_FAILURE, GET_VENDOR_APPOINTMENT_REQUEST, GET_VENDOR_APPOINTMENT_SUCCESS } from "../constants/vendor.constants";

const getVendorAppointmentRequest = () => {
    return {
        type: GET_VENDOR_APPOINTMENT_REQUEST,
    };
};

const getVendorAppointmentSuccess = (vendorAppointmentData: AnyIfEmpty<object>) => {
    return {
        type: GET_VENDOR_APPOINTMENT_SUCCESS,
        payload: vendorAppointmentData,
    };
};

const getVendorAppointmentFailure = (vendorAppointmentError: string) => {
    return {
        type: GET_VENDOR_APPOINTMENT_FAILURE,
        payload: vendorAppointmentError,
    };
};


export const createVendorAppointment = (
    vendorObj: object,
    setLoading: Dispatch<SetStateAction<boolean>>,
    onSuccess?: (message: string) => void,
    onFailure?: (message: string) => void
) => {
    return () => {
        setLoading(true);

        return axios
            .post('/admin/vendor/create-vendor-appointment', vendorObj)
            .then((response) => {
                const status = response?.data?.statusCode;
                const message = response?.data?.message;

                if (status === 201) {
                    onSuccess && onSuccess(message);
                } else {
                    onFailure && onFailure(message);
                }
            })
            .catch((error) => {
                const message = error?.response?.data?.message || 'Something went wrong';
                onFailure && onFailure(message);
            })
            .finally(() => {
                setLoading(false);
            });
    };
};


export const getVendorAppointment = ({ search, page, limit, setTotalCount }: { search: string, page: number, limit: number, setTotalCount: Dispatch<SetStateAction<number>> }) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getVendorAppointmentRequest());
        return axios
            .get(`/admin/vendor/vendor-appointments`, {
                params: {
                    searchText: search,
                    page: page,
                    limit: limit
                }
            })
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    setTotalCount(response?.data?.count)
                    dispatch(getVendorAppointmentSuccess(response.data?.appointments))
                } else {
                    setTotalCount(0)
                    dispatch(getVendorAppointmentFailure(response.data.message))
                }
            }).catch((error) => {
                setTotalCount(0);
                dispatch(getVendorAppointmentFailure(error?.response?.data?.message || 'Something went wrong'));
            });
    }
}

export const editVendorAppointment = (id: string, vendorObj: object,
    onSuccess?: (message: string) => void,
    onFailure?: (message: string) => void,
    navigate?: AnyIfEmpty<object>) => {
    return () => {
        return axios
            .patch(`/admin/vendor/vendor-appointment/${id}`, vendorObj)
            .then((response) => {
                if (response.data.statusCode === 200) {
                    onSuccess && onSuccess(response.data.message)
                    navigate && navigate('/vendor-appointments');
                } else {
                    onFailure && onFailure(response.data.message);
                }
            }).catch((error) => {
                onFailure && onFailure(error.reponse?.data?.message);
            })
    }
}

export const deleteVendorAppointment = (id: string, onSuccess?: (message: string) => void, onFailure?: (message: string) => void) => {
    return () => {
        axios.delete(`admin/vendor/vendor-appointment/${id}`)
            .then((response) => {
                if (response.data.statusCode === 200) {
                    onSuccess && onSuccess(response?.data?.message)
                } else {
                    onFailure && onFailure(response?.data?.message)
                }
            }).catch((error) => onFailure && onFailure(error?.response?.data?.message));
    };
};